import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';

export type HomologationStatus = 'pending' | 'inProgress' | 'completed';

const STATUS_COLORS: Record<HomologationStatus, string> = {
  pending: '#E0EEFD',
  inProgress: '#FFE6A1',
  completed: '#CEF0DA',
};

export default function HomologationStatusBadge({
  status,
  translationKey,
}: {
  status: HomologationStatus;
  translationKey?: string;
}) {
  const { t } = useTranslation(translationKey ?? TranslationsKeys.HOMOLOGATION);

  return (
    <Badge
      pill
      className="fs-16 fw-400 py-2 px-4 text-dark"
      style={{ backgroundColor: STATUS_COLORS[status], width: 142 }}
    >
      {t(`status.${status}`)}
    </Badge>
  );
}
